import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import GitHubIcon from '@mui/icons-material/Celebration';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

interface CustomizedDialogsProps {
    open: boolean
    handleClose: any
}

export default function CustomizedDialogs({ open, handleClose }: CustomizedDialogsProps) {

    const openInNewTab = (url: string) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <div>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Congratulations
                    {
                        <GitHubIcon style={{ marginLeft: 15 }} fontSize={'large'} color='primary' />
                    }
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Typography gutterBottom>
                        Your GitHub Profile is ready.
                        Wanna support me?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => openInNewTab('https://www.buymeacoffee.com/edhimurwanto')} variant='contained'>
                        Buy me Coffe
                    </Button>
                    <Button autoFocus onClick={handleClose}>
                        Later
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
